<nz-modal
  [(nzVisible)]="isOpen"
  nzCentered
  [nzFooter]="null"
  nzCloseIcon=""
  nzZIndex="99"
  [nzMask]="false"
>
  <ng-container *nzModalContent>
      <div class="d-flex flex-column text-center">
        <h6 class="text-bold" style="font-size: 20px;">Add Team</h6>
        <span class="text-bold"
          >Select Verification Method</span
        >
        <span
          >Choose one of the methods below to receive the verification code</span
        >
        <div class="d-flex align-items-center gap-3 col">
          <div class="w-100 mt-3 text-nowrap d-flex gap-2 bg-mail px-2 py-3 rounded border" role="button" (click)="sendOTP()">
            <div class="d-flex align-content-center">
              <img src="https://storage.googleapis.com/komerce/icon/sms-red.svg" alt="mail" width="30px">
            </div>
            <div class="d-flex flex-column align-items-start">
              <span>Email OTP Code to</span>
              <small class="text-muted">{{emailTeam}}</small>
            </div>
          </div>
        </div>
      </div>
  </ng-container>
</nz-modal>


<app-modal-verif-otp [isOpen]="isOtpVerifOpen" [token]="token"></app-modal-verif-otp>
